import runtimeEnv from '@mars/heroku-js-runtime-env';
const env = runtimeEnv();

const loadScripts = () => {
  const scripts = [
    {
      src: "/rollbar.js",
      isLocal: true,
      attrs: [
        { name: "env", value: process.env.NODE_ENV },
        { name: "key", value: env.REACT_APP_ROLLBAR_TOKEN },
      ],
    },
    {
      src: "/inspeclet.js",
      isLocal: true,
      attrs: [{ name: "key", value: env.REACT_APP_INSPECLET_ID }],
    },
    env.REACT_APP_CHATTY_WIDGET_ID
      ? {
          src: "/chatty_widget.js",
          isLocal: true,
          attrs: [
            { name: "url", value: env.REACT_APP_CHATTY_WIDGET_URL },
            { name: "key", value: env.REACT_APP_CHATTY_WIDGET_ID },
          ],
        }
      : {
          src: "/live_chat.js",
          isLocal: true,
          attrs: [{ name: "key", value: env.REACT_APP_LIVE_CHAT_ID }],
        },
    {
      src: "https://secure.safewebservices.com/token/Collect.js",
      isLocal: false,
      attrs: [
        { name: "data-tokenization-key", value: env.REACT_APP_NMI_TOKEN_KEY },
        { name: "data-field-apple-pay-style-button-style", value: "black" },
        { name: "data-field-apple-pay-style-height", value: "46px" },
        { name: "data-field-apple-pay-style-border-radius", value: "30px" }
      ],
    },
  ];

  scripts.forEach((element) => {
    const script = document.createElement("script");
    script.src = element.isLocal ? process.env.PUBLIC_URL + element.src : element.src;
    element.attrs.forEach((element) => {
      script.setAttribute(element.name, element.value);
    });
    script.async = true;
    document.body.appendChild(script);
  });
};

export default loadScripts
